var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDemo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 67,
    viewBox: "0 0 60 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49_5442)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_49_5442",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 67
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H60V67H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_49_5442)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8 12.7999L26 1.29988C31.5 -1.20012 34.8 -0.10012 36.1 4.69988C36.1 11.4999 36.1 19.5999 36.1 29.1999C36.1 34.2999 34.7 37.6999 31.9 39.4999C29.1 41.2999 21.4 45.7999 8.7 52.9999C3.9 54.8999 1 53.2999 0.1 48.2999C0 39.9999 -0.1 29.1999 0.2 22.7999C0.3 18.0999 2.5 14.7999 6.8 12.7999Z",
    fill: "url(#paint0_linear_49_5442)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5002 17.0001L32.8002 5.50008C38.3002 3.00008 41.6002 4.10008 42.9002 8.90008C42.9002 15.7001 42.9002 23.8001 42.9002 33.4001C42.9002 38.5001 41.5002 41.9001 38.7002 43.7001C35.9002 45.5001 28.1002 50.0001 15.4002 57.2001C10.6002 59.1001 7.70018 57.5001 6.80018 52.5001C6.80018 44.2001 6.70018 33.4001 7.00018 27.0001C7.10018 22.3001 9.30018 19.0001 13.5002 17.0001Z",
    fill: "url(#paint1_linear_49_5442)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6001 21.5001L40.9001 10.0001C46.4001 7.50008 49.7001 8.60008 51.0001 13.4001C51.0001 20.2001 51.0001 28.3001 51.0001 37.9001C51.0001 43.0001 49.6001 46.4001 46.8001 48.2001C44.0001 50.0001 36.2001 54.5001 23.5001 61.7001C18.7001 63.6001 15.8001 62.0001 14.9001 57.0001C14.9001 48.7001 14.7001 37.9001 15.1001 31.5001C15.2001 26.9001 17.4001 23.6001 21.6001 21.5001Z",
    fill: "url(#paint2_linear_49_5442)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_49_5442",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 12,
    width: 37,
    height: 55
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4458 12.9912H59.6458V66.7912H23.4458V12.9912Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_49_5442)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2456 25.7911L49.4456 14.2911C54.9456 11.7911 58.2456 12.8911 59.5456 17.6911C59.5456 24.4911 59.5456 32.5911 59.5456 42.1911C59.5456 47.2911 58.1456 50.6911 55.3456 52.4911C52.5456 54.2911 44.8456 58.7911 32.1456 65.9911C27.2456 67.8911 24.4456 66.3911 23.5456 61.2911C23.5456 52.9911 23.3456 42.1911 23.7456 35.7911C23.7456 31.0911 25.9456 27.7911 30.2456 25.7911Z",
    fill: "url(#paint3_linear_49_5442)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_49_5442",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 28,
    width: 19,
    height: 26
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8318 28.5278V42.3278L33.1318 53.1278V39.3278",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_49_5442)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0317 36.528C37.8317 36.628 37.6317 36.828 37.5317 37.028C37.3317 37.328 37.2317 37.528 36.9317 38.128L33.3317 48.628C33.1317 49.128 33.0317 49.528 33.0317 49.828C33.0317 50.228 33.1317 50.428 33.4317 50.528C33.7317 50.628 34.0317 50.528 34.6317 50.228L37.7317 48.428V48.828C37.7317 49.428 37.7317 49.628 37.8317 49.828C38.0317 50.128 38.3317 50.128 38.7317 49.828C39.1317 49.528 39.5317 49.128 39.6317 48.728C39.7317 48.428 39.7317 48.128 39.7317 47.528V47.128L40.0317 46.928C40.5317 46.628 40.7317 46.528 40.9317 46.228C41.2317 45.928 41.4317 45.428 41.4317 44.928C41.4317 44.428 41.2317 44.228 40.9317 44.228C40.7317 44.228 40.5317 44.328 40.0317 44.628L39.7317 44.828V43.728C39.7317 43.128 39.7317 42.928 39.6317 42.728C39.4317 42.428 39.1317 42.428 38.7317 42.628C38.3317 42.928 37.9317 43.328 37.8317 43.728C37.7317 44.028 37.7317 44.328 37.7317 44.928V46.028L35.6317 47.228L38.8317 38.028C39.0317 37.528 39.0317 37.328 39.0317 37.028C39.0317 36.428 38.5317 36.228 38.0317 36.528Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_49_5442",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 28,
    width: 19,
    height: 26
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8318 28.5278V42.3278L33.1318 53.1278V39.3278",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_49_5442)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4318 31.1276L44.5318 32.8276C44.2318 33.0276 43.7318 33.2276 43.4318 33.8276C43.1318 34.4276 43.1318 34.9276 43.1318 35.2276V45.6276C43.1318 46.0276 43.1318 46.5276 43.4318 46.7276C43.7318 46.9276 44.2318 46.6276 44.5318 46.4276L47.4318 44.7276C49.0318 43.8276 50.1318 42.6276 51.0318 40.6276C51.7318 39.0276 51.8318 37.6276 51.8318 35.3276C51.8318 33.0276 51.8318 31.7276 51.0318 30.9276C50.1318 30.2276 49.0318 30.2276 47.4318 31.1276ZM45.5318 43.5276V34.6276L47.3318 33.6276C48.1318 33.1276 48.6318 33.1276 49.0318 33.4276C49.4318 33.8276 49.5318 34.6276 49.5318 36.7276C49.5318 38.8276 49.5318 39.7276 49.0318 40.6276C48.6318 41.4276 48.1318 42.0276 47.3318 42.4276L45.5318 43.5276Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_49_5442",
    x1: 2.2937,
    y1: 16.2539,
    x2: 33.9693,
    y2: 37.6193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E2B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6873FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_49_5442",
    x1: 9.07488,
    y1: 20.4689,
    x2: 40.7496,
    y2: 41.8338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E2B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6873FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_49_5442",
    x1: 17.1459,
    y1: 25.0073,
    x2: 48.821,
    y2: 46.3724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E2B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0886886,
    stopColor: "#0ED3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3705,
    stopColor: "#35AADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6262,
    stopColor: "#518CEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8446,
    stopColor: "#627AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6873FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_49_5442",
    x1: 25.7514,
    y1: 29.241,
    x2: 57.427,
    y2: 50.6065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E2B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0886886,
    stopColor: "#0ED3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3705,
    stopColor: "#35AADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6262,
    stopColor: "#518CEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8446,
    stopColor: "#627AFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6873FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49_5442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.6,
    height: 66.8,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDemo);
export default __webpack_public_path__ + "static/media/logo-demo.18bee4bbc9b98c78959a760800b3e3a4.svg";
export { ForwardRef as ReactComponent };